"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLE_TEXTS = exports.CONTENTS_SEARCH_IDS = void 0;
exports.CONTENTS_SEARCH_IDS = {
    FORM: 'js-contents-search-product-form',
    WARNING_LABEL_BUTTON: 'js-product-type-button-0',
    LASER_LABEL_BUTTON: 'js-product-type-button-1',
    PRODUCT_TYPE_INPUT: 'js-contents-search-product-type-input',
    WARNING_OPTIONS: 'js-contents-search-warning-options',
    WARNING_SUB_OPTIONS: 'js-contents-search-warning-sub-options',
    PARENT_CATEGORY: 'js-contents-parent-options-list',
    CHILD_SYMBOL_MARK: 'js-contents-child-symbol-mark',
    CHILD_SYMBOL_MARK_ARROW: 'js-contents-child-symbol-mark-arrow',
    LASER_OPTIONS: 'js-contents-search-laser-options',
    LASER_SUB_OPTIONS: 'js-contents-search-laser-sub-options',
    SEARCH_BUTTON: 'js-contents-search-button',
    RESET_BUTTON: 'js-contents-search-reset-button',
    OTHER_OPTIONS: 'js-contents-other-options',
    TOGGLE_BUTTON: 'js-contents-toggle-open-button',
    TOGGLE_BUTTON_ICON: 'js-contents-toggle-open-button-icon',
    TOGGLE_BUTTON_TEXT: 'js-contents-toggle-button-text',
    LASER_CLASS_RANKS_CONTAINER: 'js-contents-laser-class-ranks-container',
    LASER_TYPES_CONTAINER: 'js-contents-laser-types-container',
    LASER_WAVELENGTH_CONTAINER: 'js-contents-laser-wave-length-container',
};
exports.STYLE_TEXTS = {
    OPTION_OPEN: 'height: auto; margin-top: 1rem;',
    OPTION_CLOSE: 'height: 0; margin-top: 0;',
};
